export default {
    anexosLicitacao: [],
    comissao: {},
    comissaoBusca: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        filtros: {
            descricaoSigla: {
                value: null,
                default: null,
                label: 'Nome ou Sigla'
            }
        }
    },
    defaultLoadingMessage: 'Processando...',
    file: {
        api: 'hal/public/arquivos',
        maxSize: '30Mb'
    },
    fornecedorAceite: {},
    licitacao: {},
    possuiItemComPeriodicidade: false,
    licitacaoLegado: {},
    esclarecimentosImpugnacoesLicitacaoLegado: {},
    documentosVirtualizados: [],
    documentosVirtualizadosCredenciamento: [],
    documentosVirtualizadosPaginacao: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: 'name'
        }
    },
    licitacaoBusca: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        filtros: {
            conteudo:{
                value: null,
                default: null,
                label: 'Pesquisa'
            },
            objeto: {
                value: null,
                default: null,
                label: 'Objeto'
            },
            modalidade: {
                value: null,
                default: null,
                label: 'Modalidade'
            },
            dataAbertura: {
                value: null,
                default: null,
                label: 'Data de Abertura'
            },
            comissao: {
                value: null,
                default: null,
                label: 'Comissão'
            },
            edital: {
                value: null,
                default: null,
                label: 'Edital'
            },
            processo: {
                value: null,
                default: null,
                label: 'Processo'
            },
            estado: {
                value: null,
                default: null,
                label: 'Estado'
            },
            municipio: {
                value: null,
                default: null,
                label: 'Município'
            },
            esclarecimentoImpugnacao: {
                value: null,
                default: null,
                label: 'Esclarecimento/Impugnação'
            },
            status: {
                value: null,
                default: null,
                label: 'Status'
            },
            idOrgao: {
                value: null,
                default: null,
                label: 'Responsável'
            },
            responsavel: {
                value: null,
                default: null,
                label: 'Responsável'
            }
        }
    },
    perfilCredenciamentoEdicao: {
        value: null,
        default: false,
        label: 'Perfil'
    },
    credenciamentoBusca: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        filtros: {
            conteudo:{
                value: null,
                default: null,
                label: 'Pesquisa'
            },
            objeto: {
                value: null,
                default: null,
                label: 'Objeto'
            },
            modalidade: {
                value: null,
                default: null,
                label: 'Modalidade'
            },
            dataAbertura: {
                value: null,
                default: null,
                label: 'Data de Abertura'
            },
            comissao: {
                value: null,
                default: null,
                label: 'Comissão'
            },
            edital: {
                value: null,
                default: null,
                label: 'Edital'
            },
            processo: {
                value: null,
                default: null,
                label: 'Processo'
            },
            estado: {
                value: null,
                default: null,
                label: 'Estado'
            },
            municipio: {
                value: null,
                default: null,
                label: 'Município'
            },
            esclarecimentoImpugnacao: {
                value: null,
                default: null,
                label: 'Esclarecimento/Impugnação'
            },
            status: {
                value: null,
                default: null,
                label: 'Status'
            },
            idOrgao: {
                value: null,
                default: null,
                label: 'Responsável'
            },
            responsavel: {
                value: null,
                default: null,
                label: 'Responsável'
            }
        }
    },
    credenciamento: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        reenviarDocumentos:{
            deveMostrarBotaoReenviarDocumentos: false,
            solicitacaoId: null
        },
        solicitacaoContemItens: false,
        resetReenviarDocumentos(){
            this.reenviarDocumentos.deveMostrarBotaoReenviarDocumentos = false
            this.reenviarDocumentos.solicitacaoId = null
        },
        demanda: {
            paginacao: {
                page: 1, rowsPerPage: 10, sortBy: 'id', descending: false
            }
        },
    },
    resultadoSolicitacaoCredenciamento: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        }
    },
    planoFaturas: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: 'id', descending: true
        },
        filtros: {
            idUsuario: {
                value: null,
                default: null,
            }
        }
    },
    cobrancasPorAssinatura: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: 'id', descending: true
        },
        filtros: {
            idAssinatura: {
                value: null,
                default: null,
            }
        }
    },
    licitacoesFavoritasFornecedorBusca: {
        paginacao: {
            page: 1, rowsPerPage: 5, sortBy: null, descending: false
        }
    },
    licitacoesFornecedorComProposta: {
        paginacao: {
            page: 1, rowsPerPage: 5, sortBy: null, descending: false
        }
    },
    linkCompraDireta: '',
    lotesLicitacao: [],
    notificacao: {},
    orgaos: [],
    propostaResumo: {},
    termoAceiteProposta: {},
    licitacaoPropostaItens: [],
    usuario: {},
    usuarioBusca: {
        filtros: {
            nomeEmailCpf: {
                value: null,
                default: null,
                label: 'Nome, Email ou CPF'
            }
        }
    },
    esclarecimentosLicitacao: [],
    impugnacoesLicitacao: [],
    processosAutocomplete: [],
    parametros: {},
    compararHash: {
        paginacao: {
            page: 1, rowsPerPage: 10, descending: true
        }
    },
    protocoloBusca: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        filtros: {
            fornecedor: {
                value: null,
                default: null,
                label: 'Fornecedor'
            },
            processo: {
                value: null,
                default: null,
                label: 'Processo'
            },
            protocolo: {
                value: null,
                default: null,
                label: 'Protocolo'
            },
            numeroHash: {
                value: null,
                default: null,
                label: 'Hash'
            },
            pesquisa: {
                value: null,
                default: null,
                label: 'Pesquisa'
            },
        }
    },
    perfil: 'comprasBR',
    novidadeDisponivel: false,
    termosBusca: {
        paginacao: {
            page: 1, rowsPerPage: 10, sortBy: null, descending: false
        },
        filtros: {
            conteudo:{
                value: null,
                default: null,
                label: 'Pesquisa'
            },
        }
    },
    analiseSolicitacaoCredenciamentoEmAnalise: {},
    relatoriosAnalisesSolicitacoesCredenciamento: [],
    participante: {numeroProcesso: '', orgao: '', razaoSocial: ''},
    novasSituacoesDocumentosCredenciamento: [],
    mostrarModalConfirmacaoReenvioDocumentoSoliciacaoCredenciamento: false,
    mostrarModalSolicitacaoEnvioDocumentoCredenciamento: false,
    loki: {
        alert: {},
        user: {},
        product: {},
        file: {},
        setupUser: {},
        avatarActions: [],
        flowbee: {
            accessToken: null,
            license: null
        }
    }
}
